import type { ReactElement } from 'react';
import { seoArticles } from '../../../packages/shared/src/seo-content';
import { HelpPage, PolicyPage, PricingPage, SupportPage } from './PublicPages';
import SeoPage from './SeoPage';
import DeleteAccount from './DeleteAccount';

// Use the same components for initial HTML and browser navigation.
export const publicPageRoutes: Record<string, ReactElement> = {
  '/help': <HelpPage/>,
  '/privacy': <PolicyPage kind="privacy"/>,
  '/terms': <PolicyPage kind="terms"/>,
  '/pricing': <PricingPage/>,
  '/support': <SupportPage/>,
  '/delete-account': <DeleteAccount/>,
  ...Object.fromEntries(Object.entries(seoArticles).map(([path, article]) => [path, <SeoPage article={article}/>])),
};
